module.exports = __webpack_public_path__ + "img/goods16_4.a27f1080.jpg";